// @flow
import React, { type Node } from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Box, Avatar, Text } from 'gestalt';

type Props = {|
  imageUrl?: string,
  name: string,
  title: string,
  subtitle?: string,
  linkURL?: ?string,
  accessory?: Node,
  isDim?: boolean,
|};

/*
 * ContactCell is a presentational component for representing a user contact with
 * an avatar image rep, and the ability to inline accessory elements (eg buttons)
 */
export default function ContactCell(props: Props) {
  const { imageUrl, name, title, subtitle, accessory, linkURL, isDim } = props;

  const style = { __style: { opacity: isDim ? 0.5 : 1.0 } };

  return (
    <Box display="flex" alignItems="center" paddingX={3} paddingY={2}>
      <Box marginRight={4} dangerouslySetInlineStyle={style}>
        <NavigateLink to={linkURL}>
          <Avatar outline size="md" name={name} src={imageUrl} />
        </NavigateLink>
      </Box>
      <Box
        display="flex"
        flex="grow"
        alignItems="stretch"
        direction="column"
        dangerouslySetInlineStyle={style}
      >
        <NavigateLink to={linkURL}>
          <Text color="darkGray" size="sm" truncate weight="bold">
            {title}
          </Text>
        </NavigateLink>
        <Text truncate size="xs">
          {subtitle}
        </Text>
      </Box>
      {accessory && <Box marginLeft={2}>{accessory}</Box>}
    </Box>
  );
}
